import { render } from "./sideMenu.vue?vue&type=template&id=3a1e636a"
import script from "./sideMenu.vue?vue&type=script&lang=js"
export * from "./sideMenu.vue?vue&type=script&lang=js"

import "./sideMenu.vue?vue&type=style&index=0&id=3a1e636a&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BeeNeeGit\\CompStoreFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__